import { Partner } from '@/model';
import {
  GetPartnerByIdResponse,
  GetPartnersItemResponse,
  GetPartnersResponse,
  PutPartnerResponse,
} from '@/services/response/partner';

export class PartnerConverter {
  static toDomainFromGetItemResponse(response: GetPartnersItemResponse): Partner {
    return {
      uuid: response.uuid,
      name: response.name,
      status: response.status,
      url: '',
      active_actions: response.active_actions || 0,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromGetResponse(response: GetPartnersResponse): Partner[] {
    return response.data.map(PartnerConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetPartnerByIdResponse): Partner {
    return {
      uuid: response.uuid,
      name: response.name,
      status: response.status,
      url: response.url,
      active_actions: 0,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutPartnerResponse): Partner {
    return {
      uuid: response.uuid,
      name: response.name,
      status: response.status,
      url: response.url,
      active_actions: 0,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
